import { MetricModel } from 'src/app/shared/models/metric.model'
import {
  createPaintExpression,
  getRoadCoverageMetricPaint,
} from '../utils/paint/road-coverage-metrics-paint-utils'
import { roadCoverageLegend } from './legends/road-coverage-legend'

export const getRoadCoverageMetricFromMap = (): MetricModel => {
  return {
    name: 'coverage',
    expression: createPaintExpression('coverage', getRoadCoverageMetricPaint('coverage')),
    key: 'coverage',
    legend: roadCoverageLegend,
  }
}
